import HeaderBar from './header-bar';
export default HeaderBar;
